import React, { forwardRef } from 'react';
import {
  CustomFormSelect,
  Option,
  Size,
} from 'shared/components/ui/custom-form-select';
import { Icon } from 'shared/components/ui/icon';
import { ID } from 'shared/types/id';
import { v4 as uuidv4 } from 'uuid';

import * as Styled from './popup-menu.style';

export type PopupMenuSelectProps = {
  label: string;
  labelSuffix?: React.ReactNode;
  options: Option[];
  onChange: (id: ID, value?: string) => void;
  selectedValue?: string;
  selectedLabel?: string;
  id?: string;
  icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  placeholder?: string;
  level?: number;
  compact?: boolean;
  canClear?: boolean;
  isFilterStyle?: boolean;
};

export const PopupMenuSelect = forwardRef<
  HTMLLabelElement,
  PopupMenuSelectProps
>(
  (
    {
      label,
      labelSuffix,
      options,
      onChange,
      selectedValue,
      selectedLabel,
      placeholder,
      icon,
      id = uuidv4(),
      level,
      compact,
      canClear,
      isFilterStyle,
    },
    ref,
  ) => {
    const _onChange = (value?: string) => onChange(id, value);

    return (
      <Styled.SelectContainer
        ref={ref}
        htmlFor={id}
        $level={level}
        $compact={!!compact}
        $noHover
      >
        {!!icon && (
          <Styled.AffixContainer $isSelected={false}>
            <Styled.IconContainer>
              <Icon icon={icon} />
            </Styled.IconContainer>
          </Styled.AffixContainer>
        )}
        <Styled.SelectContent>
          <Styled.SelectLabel>
            {label}
            {labelSuffix}
          </Styled.SelectLabel>
          <Styled.Select $isFilterStyle={isFilterStyle}>
            <CustomFormSelect
              id={id}
              onChange={_onChange}
              options={options}
              value={selectedValue}
              selectedLabel={selectedLabel}
              placeholder={placeholder}
              size={Size.ExtraSmall}
              canClear={canClear}
              noOverflow
            />
          </Styled.Select>
        </Styled.SelectContent>
      </Styled.SelectContainer>
    );
  },
);
